angular.module('lf.common')

.directive('gtmTrack', function ($parse, gtmService) {
  return function link (scope, el, attrs) {
    var defaults = {
      anchorLinkDelay: false,
      anchorLinkDelayTime: 500
    }
    
    var params = $parse(attrs.gtmTrack)(scope);
    var options = $parse(attrs.gtmTrackOptions)(scope);
    var opts = $.extend(true, {}, defaults, options);
    
    el.on('click', function (e) {
      gtmService.track(params);
      
      var href = attrs.href;
      
      if (opts.anchorLinkDelay && href && href !== '#') {
        e.preventDefault();
        e.stopPropagation();
        
        setTimeout(function () {
          window.location = href;
        }, opts.anchorLinkDelayTime);
      }
    });
    
  }
});
